import { network } from 'services/network';

export const getTagsAssignedToCurrentCustomerSubPrograms = () => {
    return network.get('api/bo/getTagsAssignedToCurrentCustomerSubPrograms').then((response) => {
        return response.data;
    });
};
